(function () {
    //sort header banners by order
    //this code should be executed as soon as possible
    var $slider = $('[data-carousel="banners"]');
    if (!$slider.length) return false;
    var get = function (el) {
        return parseInt($(el).attr('data-order'), 10);
    };
    var sort = function (a, b) {
        return (get(b) < get(a)) ? 1 : -1;
    };
    $slider.find('[data-slide]').sort(sort).appendTo($slider);
})();

//header banners carousel
//API: https://owlcarousel2.github.io/OwlCarousel2
(function () {
    var $slider = $('[data-carousel="banners"]');
    if (!$slider.length) return false;
    var $wrapper = $slider.parent('.c-carousel--banners');
    var $slides = $slider.find('[data-slide]');
    var $dots = $wrapper.find('.c-carousel-controls ul');
    var $btns = $wrapper.find('.c-carousel-controls button');
    var $counter = $wrapper.find('.c-carousel-counter');
    var count = 0;
    var dots = '';
    var speed = 400;

    $slides.each(function (index) {
        var CID = Math.floor(Math.random() * 999999);
        var $slide = $(this);
        $slide
            .attr('data-index', index)
            .attr('data-cid', CID);
        dots += '<li class="o-btn o-btn--dot u-m--zero u-p--zero u-relative u-cursor--pointer u-transition--base" data-index="' + index + '" />';
        count++;
    });

    var play = function ($video) {
        $video.addClass('video--playing').find('video').get(0).play();
    };

    var stop = function () {
        $slider.find('[data-video]').filter('.video--playing').each(function () {
            var $video = $(this);
            $video.removeClass('video--playing').find('video').get(0).pause();
        });
    };

    var load = function ($video) {
        var video = '<video loop playsinline muted>' +
            '<source src="' + $video.attr('data-video') + '" type="' + $video.attr('data-type') + '" />' +
            '</video>';
        $wrapper.addClass('video--loading');
        $video.addClass('loading').html(video);
        $video.find('video').on('canplaythrough', function () {
            $wrapper.removeClass('video--loading');
            $video.removeClass('loading').addClass('video--loaded');
            play($video);
        });
    };

    // var owlDuration = $slider.data('speed');
    // var returnSpeed = owlDuration - 500;

    var active = function () {
        var $slide = $slider.find('.active').find('[data-slide]');
        var $white_mode = $slide.attr('data-white-mode');
        var CID = parseInt($slide.attr('data-cid'), 10);
        var $poster = $slide.find('.slide-poster');
        var $particles = $slide.find('.slide-particles');
        var $video = $slide.find('[data-video]');
        var src_json = $particles.attr('data-json');
        var poster = $poster.css('background-image');
        var index = parseInt($slide.attr('data-index'), 10);
        // Loading images
        var $poster_desktop = $slide.find('.js-slide-poster--desktop');
        var $poster_mobile = $slide.find('.js-slide-poster--mobile');

        $dots.removeClass('active').filter('[data-index="' + index + '"]').addClass('active');
        $counter.text(index + 1 + '/' + count);

        if (typeof src_json != 'undefined' && src_json != '') {
            $particles.attr('id', 'particles-' + CID);
            particlesJS.load('particles-' + CID, src_json);
        }

        if ($video.length) {
            if (!$video.hasClass('loading') && $video.find('video').length) {
                play($video);
            } else {
                load($video);
            }
        }

        if ($white_mode == 'true') {
            $('body').addClass('carousel--white');
            $('.c-header').removeClass('u-wh').addClass('u-bl');
            $('.o-btn--carousel').addClass('o-btn--carousel-white');
        } else {
            $('body').removeClass('carousel--white');
            $('.c-header').removeClass('u-bl').addClass('u-wh');
            $('.o-btn--carousel').removeClass('o-btn--carousel-white');
        }
        
        // load desktop poster
        if ($poster_desktop.length && !$poster_desktop.hasClass('poster--loaded') && $poster_desktop.parent().is(":visible")) {
            var src_poster_desktop = $poster_desktop.attr('data-slide-bg').replace(/(^url\()|(\)$|[\"\'])/g, '');
            $wrapper.addClass('poster--loading');
            $wrapper.find('.o-loader').addClass('o-loader--active');
            var $poster_img_desktop = $('<img />').attr('src', src_poster_desktop).on('load', function () {
                setTimeout(function() {
                    $poster_desktop.css('background-image', 'url(' + src_poster_desktop + ')');
                    $wrapper.removeClass('poster--loading');
                    $poster.addClass('poster--loaded');
                    $wrapper.find('.o-loader').removeClass('o-loader--active');
                }, 500);
            });
        }

        // load desktop poster
        if ($poster_mobile.length && !$poster_mobile.hasClass('poster--loaded') && $poster_mobile.parent().is(":visible")) {
            var src_poster_mobile = $poster_mobile.attr('data-slide-bg').replace(/(^url\()|(\)$|[\"\'])/g, '');
            $wrapper.addClass('poster--loading');
            $wrapper.find('.o-loader').addClass('o-loader--active');
            var $poster_img_mobile = $('<img />').attr('src', src_poster_mobile).on('load', function () {
                setTimeout(function() {
                    $poster_mobile.css('background-image', 'url(' + src_poster_mobile + ')');
                    $wrapper.removeClass('poster--loading');
                    $poster.addClass('poster--loaded');
                    $wrapper.find('.o-loader').removeClass('o-loader--active');
                }, 500);
            });
        }




        // if ($slide.data('autoplay')) {
        //     console.log('autoplayON');
        //     $slide.trigger('start.owl.autoplay');
        //     owlLoader.css(resetLoaderStyles);
        //     owlLoader.css(loaderStyles);
        // } else {
        //     console.log('autoplayOff');
        //     $slide.trigger('stop.owl.autoplay');
        //     owlLoader.css(resetLoaderStyles);
        //
        // }
        //
        // if ($slide.data('revert')) {
        //     setTimeout(function() {
        //         $slider.trigger('prev.owl.carousel');
        //     }, returnSpeed); // wide place
        //     owlLoader.css(resetLoaderStyles);
        //     owlLoader.css(loaderStyles);
        // }

        $btns
            .removeClass('disabled')
            .filter('.btn--prev').addClass(index + 1 == 1 ? 'disabled' : '').end()
            .filter('.btn--next').addClass(index + 1 == count ? 'disabled' : '');
    };

    // var $autoplay = $slider.data('autoplay');
    // var loaderDuration = owlDuration / 1000 + 's';
    // var owlLoader = $('.c-carousel--banner-loader-bar');
    //
    // var resetLoaderStyles = {
    //     'width': '0',
    //     'transition-duration': '0s'
    // };
    // var loaderStyles = {
    //     'width': '100%',
    //     'transition-duration': loaderDuration
    // };

    var slider = $slider.owlCarousel({
        css: true,
        loop: count>1,
        responsiveClass: false,
        smartSpeed: speed,
        nav: false,
        dots: false,
        margin: 0,
        navText: ["", ""],
        mouseDrag: count>1,
        items: 1,
        lazyLoad: true,
        autoHeight: false,
        // autoplay:true,
        // autoplayTimeout: owlDuration,
        // autoplayHoverPause:false,
        onInitialized: function () {
            $wrapper.addClass('is-loaded');
            setTimeout(function () {
                active();
            }, 100);
        }
    });

    slider.on('loaded.owl.lazy', function () {
        $slider.find('.active').find('.owl-lazy').parent().addClass('img--loaded');
    });

    if (count > 1) {
        $dots.html(dots);
        $dots = $dots.find('li');
        $('body').addClass('carousel--available');
        $dots.on('click', function (e) {
            e.preventDefault();
            var index = parseInt($(this).attr('data-index'), 10);
            slider.trigger('to.owl.carousel', [index, speed, true]);
        });
        $btns.on('click', function () {
            slider.trigger(($(this).hasClass('o-btn--carousel-prev') ? 'prev.owl.carousel' : 'next.owl.carousel'));
        });
        slider.on('changed.owl.carousel', function () {
            // owlLoader.css(resetLoaderStyles);
            stop();
            setTimeout(function () {
                active();
            }, 100);
        });
    }

    /* Resize on sidebar show/hide */
    $(document).on('sidebarChanged', function () {
        $slider.data('owl.carousel')._invalidated.width = true;
        slider.trigger('refresh.owl.carousel');
    })

})();